export const CONFIRM_UNSAVED_CHANGES =
  'You will lose any unsaved changes. Are you sure you would like to continue?'
